import React from "react";

function resultCardImg(code) {
    return `/assets/images/cards/${code && code !== "1" ? code : "1"}.svg`;
}

function marketWinLabel(val) {
    const n = Number(val);

    if (n === 1) return "WINNER";
    if (n === 0) return "LOSER";

    return val != null && val !== "" ? String(val) : "-";
}

const formatResultDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

const DusDamResult = ({ resultData }) => {

    return (
        <>
            <div class="left-content" >
                {resultData?.length > 0 &&
                    resultData.map((dataObj, index) => {

                        //console.log("DUSDAM RESULT", dataObj);

                        const resultNo = Number(dataObj.result);

                        const winnerCard = {
                            label: dataObj[`cat_rnr${resultNo}`] || "-",
                            cardCode: dataObj.ac1,
                            status:
                                dataObj.evt_status === "CLOSED"
                                    ? "WINNER"
                                    : ""
                        };


                        return (
                            <div
                                key={index}
                                className="card"
                                style={{
                                    border: "1px solid rgb(204, 204, 204)",
                                    borderRadius: "8px",
                                    background: "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))"
                                }}
                            >
                                <div
                                    class="card-header no-border"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                        marginTop: "5px",
                                        background: "transparent",
                                        borderBottom: "solid 1px #00000015"
                                    }}
                                >
                                    {formatResultDate(dataObj.evt_od)} - <b>ID=</b> {dataObj._id}
                                </div>
                                <div class="card-body" style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "8px" }}>
                                    <div class="players-table" style={{ textAlign: "center", width: "100%" }}>
                                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                            <tbody>
                                                <tr style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-evenly" }}></tr>

                                                <tr style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-evenly" }}>
                                                    <td class="TdResults TdResultsWin">
                                                        <div class="player-cards" style={{ display: "flex", flexDirection: "column", alignItems: "center", overflowWrap: "break-word" }}>
                                                            <div class="player-name" style={{ fontWeight: "bold", textAlign: "center", width: "100%" }}>
                                                                {winnerCard.label}
                                                            </div>
                                                            <div class="card-images" style={{ display: "flex", justifyContent: "center", gap: "3px", flexWrap: "wrap", width: "100%" }}>
                                                                <img
                                                                    src={resultCardImg(winnerCard.cardCode)}
                                                                    alt=""
                                                                    style={{
                                                                        width: "45px"
                                                                    }}
                                                                />
                                                            </div>
                                                            <div class="player-status bgwinner" style={{ color: "rgb(0, 0, 0)", marginTop: "5px", fontSize: "14px", fontWeight: "bold", textAlign: "center", width: "100%" }}>
                                                                {winnerCard.status}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
            <style>
                {`
                .TdResults {
                    padding: 0px;
                    vertical-align: top;
                    flex: 1 1 auto;
                    box-sizing: border-box;
                    max-width: calc(33.33% - 20px);
                    min-width: 120px;
                    background: green !important;
                    border-radius: 10px;
                    margin: 1px;
                } 
                    .bgwinner {
                    border-radius: 10px;
                    background-color: #cf8d2e !important;
                }
                    @media(max-width:576px){
                        .card{
                            margin-bottom: 0.25rem!important;
                        }
                        
                    }
                `}
            </style>

        </>
    );
};

export default DusDamResult;